import { useAppSelector } from "../../store/storeHooks"
import { selectAuthenticatedUser } from "../../login/loginSelectors"
import { useApiQuery } from "../../../core/api/useApiQuery"
import { Card, Grid } from "@mui/material"
import { ProfileCard } from "../../profile/components/ProfileCard"
import { makeStyles } from "tss-react/mui"
import { UserLanguageCard } from "./UserLanguageCard"
import { UserNotificationSettings } from "./UserNotificationSettings"
import { UserPasswordCard } from "./UserPasswordCard"
import { getUserDetails, UserQuery } from "../../users/userApi"

const useStyles = makeStyles()((theme) => ({
    wrap: {
        display: "grid",
        gap: "2rem",
    },
    box: {
        border: `1px solid ${theme.palette.tailwind.slate[100]}`,
        borderRadius: ".75rem",
        boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.08)",
        display: "flex",
        flexDirection: "column",
        background: "white",
        padding: "2rem",
        width: "100%",
    },
}))

export const UserProfileContent = () => {
    const { classes } = useStyles()
    const user = useAppSelector(selectAuthenticatedUser)

    if (!user) {
        return null
    }

    const { data: userDetails } = useApiQuery(getUserDetails, {
        queryName: UserQuery.USER_DETAILS,
        dependencies: {
            userId: user.id ?? 0,
        },
        enabled: Boolean(user.id),
        select: (data) => data.user,
    })

    if (!userDetails) {
        return null
    }

    return (
        <Grid container spacing="1.5rem" alignItems="flex-start" columns={{ xs: 8, md: 12 }}>
            <Grid item xs={8} md={7} className={classes.wrap}>
                <Card className={classes.box}>
                    <ProfileCard user={userDetails} />
                </Card>
            </Grid>

            <Grid item xs={8} md={5} className={classes.wrap}>
                <Card className={classes.box}>
                    <UserLanguageCard>
                        <UserNotificationSettings userId={user.id ?? 0} />
                    </UserLanguageCard>
                </Card>
                <Card className={classes.box}>
                    <UserPasswordCard />
                </Card>
            </Grid>
        </Grid>
    )
}
